import type { ComponentProps, ReactNode } from "react";
import { Modal as NativeModal } from "../ui/Modal";
import { cn } from "../../lib/utils";
import { DesignSystem, usePlanningBaseline } from "../ui/DesignSystem";
import "./controls.css";

// Compatibility imports for the representative migration screens. All business
// controls now have one implementation and one accessibility/disabled contract.
export { Button } from "../ui/Button";
export { Field, Input, Textarea } from "../ui/Field";

/** Native top layer is deliberately retained during migration: editors can be
 * nested in the current worker drawer, whose inert background excludes portals.
 * Saving/close blocking and focus restoration remain owned by the existing shell. */
export function Modal({ className, children, ...props }: ComponentProps<typeof NativeModal> & { children: ReactNode }) {
  const baseline = usePlanningBaseline();
  return <DesignSystem><NativeModal {...props} className={cn(!baseline && "ui-next next-dialog", className)}>{children}</NativeModal></DesignSystem>;
}
